import { useFormikContext } from 'formik';

import {
  DemographicFormData,
  getValuesForAudienceTypeChange,
} from '../../../../util/demographics';

import FormGroup from 'components/common/forms/FormGroup';

import { AudienceTypeOptions } from './AudienceTypeOptions';

export const DefineAudienceCard = ({
  audienceSource,
  panelProvider,
}: {
  audienceSource: string;
  panelProvider: string | null;
}) => {
  const { setValues, values } = useFormikContext<DemographicFormData>();

  return (
    <div className="grid grid-cols-[300px_1fr]">
      <div>Who do you want to talk to?</div>
      <FormGroup>
        <AudienceTypeOptions
          audienceSource={audienceSource}
          onChange={(value) => {
            setValues(
              getValuesForAudienceTypeChange({
                formData: values,
                newAudienceType: value,
              }),
            );
          }}
          panelProvider={panelProvider}
          value={values.audienceProfile.audienceType}
        />
      </FormGroup>
    </div>
  );
};
